<template>
  <div class="container" ref="container">
    <div v-show="isLeftShown" @click="arrowLeftClick" class="slideLeft slideButton"></div>
    <div v-show="isRightShown" @click="arrowRightClick" class="slideRight slideButton"></div>
    <canvas
      class="canvas-render"
      @mousemove="isMoving($event)"
      @mousedown="moveOn($event)"
      @mouseup="moveOff()"
      ref="canvas"
    ></canvas>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js';

export default {
  name: 'Diaporama',
  mounted() {
    this.animating = true;
    window.addEventListener('mouseup', this.moveOff);
    window.addEventListener('wheel', this.wheelMoving);
    window.addEventListener('resize', this.resize);
    window.addEventListener('pointerup', this.moveOff);

    this.initScene();
    this.animate();
  },
  data: function() {
    return {
      imgDimensions: {},
      stage: null,
      renderer: null,
      canMove: false,
      backgroundSprite: null,
      glassContent: null,
      glassFilter: null,
      currentX: 0,
      currentY: 0,
      stageDimensions: {
        width: null,
        height: null,
      },
      animating: false,
    };
  },
  computed: {
    background() {
      return require(`../../../../public/transition_img.jpg`);
    },
    glass() {
      return require(`../../../../public/demo/glass/glass-opacitymap.png`);
    },
    glassOutline() {
      return require(`../../../../public/demo/glass/glass-outline.png`);
    },
    isLeftShown() {
      if (this.glassContent) {
        return this.glassContent.x < 0;
      }
      return false;
    },
    isRightShown() {
      if (this.glassContent) {
        return this.glassContent.x > -this.imgDimensions.width + this.stageDimensions.width;
      }
      return false;
    },
  },
  methods: {
    async initScene() {
      this.setDimensions();
      await this.setImageDim();
      this.renderer = PIXI.autoDetectRenderer({
        width: this.stageDimensions.width,
        height: this.stageDimensions.height,
        view: this.$refs['canvas'],
      });

      this.stage = new PIXI.Container();
      this.renderer.plugins.interaction.cursorStyles.default = "url('../../../assets/ic-grab.svg'),pointer";
      this.renderer.plugins.interaction.cursorStyles.hover = "url('../../../assets/ic-grab.svg'),pointer";
      this.stage.interactive = true;
      this.backgroundSprite = new PIXI.Sprite.from(this.background);
      this.backgroundSprite.height = this.renderer.height;
      this.backgroundSprite.height = this.imgDimensions.height;
      this.backgroundSprite.width = this.imgDimensions.width;

      const glassSprite = new PIXI.Sprite.from(this.glass);
      glassSprite.width = (this.renderer.width * 60) / 100;
      glassSprite.height = (this.renderer.width * 60) / 100;
      glassSprite.x = (this.renderer.width * 20) / 100;

      this.glassContent = new PIXI.Sprite.from(this.background);
      this.glassContent.height = this.imgDimensions.height;
      this.glassContent.width = this.imgDimensions.width;
      this.glassContent.mask = glassSprite;

      //grey Filter
      this.glassFilter = new PIXI.Sprite(PIXI.Texture.WHITE);
      this.glassFilter.width = this.renderer.width;
      this.glassFilter.height = this.renderer.height;
      this.glassFilter.tint = 0x7d7d7d;
      this.glassFilter.mask = glassSprite;
      this.glassFilter.alpha = 0;

      //glasses outline
      const glassOutline = new PIXI.Sprite.from(this.glassOutline);
      glassOutline.width = (this.renderer.width * 60) / 100;
      glassOutline.height = (this.renderer.width * 60) / 100;
      glassOutline.x = (this.renderer.width * 20) / 100;

      //add in scene order is important
      this.stage.addChild(this.backgroundSprite);
      this.stage.addChild(glassSprite);
      this.stage.addChild(this.glassContent);
      this.stage.addChild(this.glassFilter);
      this.stage.addChild(glassOutline);
    },
    destroyScene() {
      this.stage.destroy(true, true, true);
      this.renderer.destroy();
      this.stage = null;
      this.renderer = null;
    },
    resize() {
      this.destroyScene();
      this.initScene();
    },
    arrowLeftClick() {
      this.move(200);
    },
    arrowRightClick() {
      this.move(-200);
    },
    async setImageDim() {
      return new Promise(resolve => {
        let backgroundImg = new Image();
        backgroundImg.src = this.background;
        backgroundImg.onload = () => {
          const ratio = backgroundImg.width / backgroundImg.height;
          this.imgDimensions = { width: this.stageDimensions.height * ratio, height: this.stageDimensions.height };
          resolve();
        };
      });
    },
    setDimensions() {
      const ratio = 16 / 9;
      this.stageDimensions.width = this.$refs.container.clientHeight * ratio;
      this.stageDimensions.height = this.$refs.container.clientHeight;
    },
    moveOn(event) {
      this.canMove = true;
      this.currentX = event.screenX;
      this.currentY = event.screenY;
    },
    moveOff() {
      this.canMove = false;
    },
    wheelMoving(event) {
      this.move(event.deltaY);
    },
    isMoving(event) {
      if (this.canMove) {
        this.move((event.screenX - this.currentX) * -3);
      }
      this.currentX = event.screenX;
      this.currentY = event.screenY;
    },
    move(value) {
      if (
        this.glassContent.x + value < 0 &&
        this.glassContent.x + value > -this.imgDimensions.width + this.stageDimensions.width
      ) {
        this.glassContent.x += value;
        this.backgroundSprite.x += value;
        this.glassFilter.alpha =
          (Math.abs(this.glassContent.x) * 0.8) / (this.imgDimensions.width - this.stageDimensions.width);
      } else if (this.glassContent.x + value >= 0) {
        this.glassContent.x = 0;
        this.backgroundSprite.x = 0;
      } else if (this.glassContent.x + value <= -this.imgDimensions.width + this.stageDimensions.width) {
        this.glassContent.x = -this.imgDimensions.width + this.stageDimensions.width;
        this.backgroundSprite.x = -this.imgDimensions.width + this.stageDimensions.width;
      }
    },
    animate() {
      // render the stage
      if (this.animating) {
        if (this.stage) {
          this.renderer.render(this.stage);
        }
        requestAnimationFrame(this.animate);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.moveOff);
    window.removeEventListener('wheel', this.wheelMoving);
    window.removeEventListener('resize', this.resize);
    window.removeEventListener('pointerup', this.moveOff);

    this.animating = false;
    this.destroyScene();
  },
};
</script>

<style scoped>
.slideButton {
  position: absolute;
  z-index: 13;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  top: 50%;
  background-color: white;
  border: 1px rgba(26, 26, 26, 0.15) solid;
  font-size: 20px;
  padding: 9px 0 0 0;
}

.slideButton:hover {
  border: 1px solid black;
  cursor: pointer;
}

.slideLeft:after {
  font-family: 'Palatino Linotype', 'Book Antiqua';
  content: '<';
}

.slideRight {
  right: 5%;
}

.slideRight:after {
  font-family: 'Palatino Linotype', 'Book Antiqua';
  content: '>';
}

.slideLeft {
  left: 5%;
}
.canvas-render {
  cursor: url('../../../assets/ic-grab.svg'), pointer;
  touch-action: none;
}
.container {
  width: 100%;
  height: 100%;
}
</style>
